export interface GetUserWorkingSessionsResponseDto {
  sessionId: string;
  startTime: string;
  endTime: string;
  sessionStartWeek: string;
  duration: number;
  sessionCallDuration: number;
  callCount: number;
  focusDuration: number;
  activityDuration: number;
  totalDuration: number;
  totalSessionCallDuration: number;
  totalActivityDuration: number;
  totalFocusDuration: number;
  activityCount: number;
  contextSwitches: number;
  focusScore: number;
  digitalIntensity: number;
  focusPercentage: number;
  dayCount: number;
  callDayCount: number;
  weekCount: number;
  callWeekCount: number;
  updatedAt: string;
}
